import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export function IconInfo({ width = '16', height = '16', className, ...rest }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            width={width}
            height={height}
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm1.3 12a1 1 0 0 0 0-2H9V6.8c0-.5-.2-.8-.7-.8H6.7a1 1 0 0 0 0 2H7v2h-.3a1 1 0 0 0 0 2h2.6zM8 2.7a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6z"
            />
        </svg>
    );
}

export default IconInfo;
